<div class="action-container">
    Realiza el pago con tu cuenta de Cheques, Ahorro y Business.
  </div>
  <div class="line-decorator"></div>
  <div class="action-container">
    <div class="action-container">
      <button
        class="btn btn-danger action-btn"
        (click)="flashPaymentService.achPayment()"
      >
        Pagar &nbsp;
        {{ flashPaymentService.controller.operationAmount | currency }}
      </button>
    </div>
  </div>
